App.controller('HealthInsuranceWithPaymentsCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', '$mdDialog', 'Config', function ($scope, $stateParams, $sce, $state, $http, $mdDialog, Config) {
    
}]);
